// import $ from "jquery"
import device from '@/api/path/device'
import serviceProxy from './ServiceProxy'

class Shareds{
    isEmpty = (obj) => {
        if(
            typeof obj == 'undefined'
            || obj == null
            || obj.length<=0
        ){
            return true
        }
        return false
    }

    // unixtoStr(unix){//處理時間格式 Unix Timestamp 
    //     let da = new Date(unix)
    //     let year = da.getFullYear()
    //     let month = String(da.getMonth() + 1).padStart(2, '0')
    //     let day = String(da.getDate()).padStart(2, '0')
    //     let hours = String(da.getUTCHours()).padStart(2, '0')
    //     let minutes = String(da.getUTCMinutes()).padStart(2, '0')

    //     let dateString = `${year}-${month}-${day} ${hours}:${minutes}`
    //     return dateString
    // }

    get_yyyymmdd(_date){//回傳yyyy‑mm‑dd
        if(!_date) return '--'
        const date = new Date(_date)
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        return `${year}/${month}/${day}`
    }

    get_yyyymmddHHmmss(date){//回傳yyyy‑mm‑dd HH-mm-ss
        const yyyy = date.getFullYear()
        const MM = String(date.getMonth() + 1).padStart(2, '0')
        const dd = String(date.getDate()).padStart(2, '0')
        const HH = String(date.getHours()).padStart(2, '0')
        const mm = String(date.getMinutes()).padStart(2, '0')
        const ss = String(date.getSeconds()).padStart(2, '0')
        return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`
    }

    thisMonth_yyyymmddHHmmss(){//取得這個月的yyyymmddHHmmss時間範圍
      const currentDate = new Date()

      const year = currentDate.getFullYear()
      const month = currentDate.getMonth() + 1 //月份0開始 所以+1

      const firstDayOfMonth = new Date(year, month - 1, 1, 0, 0, 0, 0)
      const firstDayOfNextMonth = new Date(year, month, 1, 0, 0, 0, 0)
      const lastDayOfMonth = new Date(firstDayOfNextMonth.getTime() - 1)
        
      return{
        startDate: this.get_yyyymmddHHmmss(firstDayOfMonth),
        endDate: this.get_yyyymmddHHmmss(lastDayOfMonth),
      }
    }

    today_yyyymmddHHmmss(){//取得今天的yyyymmddHHmmss時間範圍
      const currentDate = new Date()

      const year = currentDate.getFullYear()
      const month = currentDate.getMonth() + 1 //月份0開始 所以+1
      const day = currentDate.getDate()

      const startOfToday = new Date(year, month - 1, day, 0, 0, 0, 0)
      const endOfToday = new Date(year, month - 1, day, 23, 59, 59, 999)

      return{
        startDate: this.get_yyyymmddHHmmss(startOfToday),
        endDate: this.get_yyyymmddHHmmss(endOfToday),
      }
    }

    combimgUrl(uuid){//處理圖片路徑
        return process.env.VUE_APP_FILE_URL +'/'+ uuid
        // return 'http://123.205.124.87:8280/cfs/download/' + uuid
    }

    tbDataisnull(data){
        if(data === undefined
        || data === null
        || data.length == 0
        || data === ''){
            return '--'
        }else{
            return data
        }
    }

    doparamsStr(obj){//傳入物件，回傳api params需要的字串
        if(Object.keys(obj).length === 0){
            return ''
        }
        
        let paramStr = []
        for (let key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                let value = obj[key]
                if (value !== '' && value !== undefined) {
                    paramStr.push(`${key}=${value}`)
                }
            }
        }
        return paramStr.join('&')
    }

    initSelet(){//重製有"所有"選項的下拉選單
       return  [{
            label: '所有',
            value: '',
        }]
    }

    allbuild(commulityId){//社區下所有棟別資料
        return new Promise((resolve) => {
            serviceProxy.getApi(`kbro_api/api/v1/building/${commulityId}`)
            .then((res)=>{
                // console.log(res.data)
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })
    }

    allfloor(){//所有樓層資料
        return new Promise((resolve) => {
            serviceProxy.getApi('kbro_api/api/v1/floor/0')
            .then((res)=>{
                // console.log(res.data)
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })
    }

    allFloorArea(communityId, bid, fid) { //根據社區編號取得棟別樓層區域列表
        return new Promise((resolve, reject) => {
            serviceProxy.getApi(`kbro_api/api/v1/building/floor-areas/${communityId}?buildingId=${bid}&floorId=${fid}`)
            .then((res)=>{
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })
    }

    allhouseid(commulityId){//社區下所有戶別資料
        return new Promise((resolve) => {
            serviceProxy.getApi(`kbro_api/api/v1/household/community/${commulityId}`)
            .then((res)=>{
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })
        // 
    }
    
    getdevice(commulityId){//社區下所有設備
        return new Promise((resolve) => {
            serviceProxy.getApi(`WebAPI/api/Device/list?commulityId=${commulityId}`)
            .then((res)=>{
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })
    }

    floorbybuild(id){//用棟別取得樓層資料
        return new Promise((resolve) => {
            serviceProxy.getApi(`kbro_api/api/v1/floor/${id}`)
            .then((res)=>{
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })
    }

    houseidbyfloor(bid, fid, commulityId){//用樓層取得戶別資料
        return new Promise((resolve) => {
            serviceProxy.getApi(`kbro_api/api/v1/household/community/${commulityId}?buildingId=${bid}&floorId=${fid}`)
            .then((res)=>{
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })    
    }

    allcard(communityId){//社區下所有卡片
        return new Promise((resolve) => {
            serviceProxy.getApi(`kbro_api/api/v1/card/listCard?communityId=${communityId}`)
            .then((res)=>{
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })
    }

    alluser(commulityId){//社區下所有使用者
        return new Promise((resolve) => {
            serviceProxy.getApi(`AccountAPI/api/User/listinfo/${commulityId}`)
            .then((res)=>{
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })    
        
    }

    allrole(commulityId){//社區下所有角色
        return new Promise((resolve) => {
            serviceProxy.getApi(`AccountAPI/api/Group/listSub?groupId=${commulityId}`)
            .then((res)=>{
                resolve(res.data)
            })
            .catch((err)=>{console.log(err)})
        })    
        
    }

    filepass(file){//判斷上傳檔案是否符合格式
        let filename = file.name.split('.').pop()
        filename = filename.toLowerCase()
        console.log(filename)
        const image = ['jpg', 'jpeg', 'png']

        if(image.indexOf(filename) > -1){//是否為圖片
            return true //符合
        }else{
            return false //不符合
        }
    }

    findName(list, want, type){
        if(type === 'build'){//從全部棟別列表篩選
          return  list.find((s)=>s.buildingId === parseInt(want))
        }

        if(type === 'floor'){//從全部樓層列表篩選
          return  list.find((s)=>s.floorId === parseInt(want))
        }

        if(type === 'nvr' || type === 'device'){//從設備列表找到攝影機的nvr主機 or 從設備列表找資料
          return  list.find((s)=>s.id === want)
        }

        if(type === 'device-modelname'){//從人員列表篩選
          return  list.find((s)=>s.modelName === want)
        }

        if(type === 'user'){//從人員列表篩選
          return  list.find((s)=>s.uid === want)
        }

        if(type === 'username'){//從人員列表篩選
          return  list.find((s)=>s.account === want)
        }

        if(type === 'userbyphone'){//從人員列表篩選by手機
          return  list.find((s)=>s.pushInfo?.sms?.token === want)
        }

        if(type === 'role'){//從角色列表篩選
            return list.find((s)=>s.groupId === want)
        }
    }

    transtriggertype(triggertype){//轉換觸發類型，不想改外包的定義
        // console.log(triggertype)
        switch(triggertype){
            case '所有':
              return ''
            case 'warning':
              return 'MultiDevVal'
            case 'detection':
              return 'MultiDevVal'
            case 'timing':
              return 'Cron'
            case 'warningtext':
              return '警戒觸發' 
            case 'detectiontext':
              return '偵測觸發'   
            case 'timingtext':
              return '定時觸發'        
        }
    }

    transactiontype(actiontype){//轉換執行類型，不想改外包的定義
        switch(actiontype){
            case 'sms':
              return '發送SMS'
            case 'mail':
              return '發送Email'
            case 'WebSocketDeviceAlarmMsgAction':
              return '彈跳告警視窗+截圖影像'
            case 'voice_call':
              return '外撥電話語音' 
            default: return actiontype
        }
    }


    transai(ai){//轉換ai觸發值
        switch(ai){
            case 'ai_human':
            return '偵測入侵'

            case 'ai_climb':
            return '偵測爬牆'

            case 'ai_stay':
            return '偵測停留'

            case 'ai_gather':
            return '偵測群聚'

            case 'ai_crowd':
            return '偵測人潮'

            case 'ai_fall':
            return '偵測跌倒'

            case 'ai_home':
            return '偵測到家'

            case 'aiDetection':
            return 'AI偵測'    
        }
    }
//===================================設備類型的定義==================================
    isCamera(modelId){//是攝影機就回傳true    
        modelId = parseInt(modelId)
        let camera = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 50, 51, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66]
        // return door.find(item=> item === modelId)
        return camera.includes(modelId)
    }

    isDoor(modelId){//是門就回傳true
        // console.log(modelId)
        modelId = parseInt(modelId)
        let door = [1, 27, 46]
        return door.includes(modelId)
    }

    isNvr(modelId){//是Nvr就回傳true
        modelId = parseInt(modelId)
        let NVR = [2, 15, 16, 17, 18, 19]
        return NVR.includes(modelId)
    }

    isPir(modelId){//是人體感應器就回傳true
        modelId = parseInt(modelId)
        let pir = [30]
        return pir.includes(modelId)
    }

    isSmoke(modelId){//是煙霧感應器就回傳true
        modelId = parseInt(modelId)
        let smoke = [29]
        return smoke.includes(modelId)
    }

    isRhtemp(modelId){//是溫溼度計就回傳true
        modelId = parseInt(modelId)
        let rh = [31, 32]
        return rh.includes(modelId)
    }

    isC1D1host(modelId){//是c1 d1的主機就回傳true
        modelId = parseInt(modelId)
        let host = [34, 36]
        return host.includes(modelId)
    }

    isOtherhost(modelId){//是其他不需要的主機就回傳true
        modelId = parseInt(modelId)
        let host = [28]
        return host.includes(modelId)
    }

    isC1(modelId){//是c1就回傳true
        modelId = parseInt(modelId)
        let c = [35]
        return c.includes(modelId)
    }

    isD1(modelId){//是d1就回傳true
        modelId = parseInt(modelId)
        let d = [37]
        return d.includes(modelId)
    }

    isalarm(modelId){//是警報器就回傳true
        modelId = parseInt(modelId)
        let d = [40]
        return d.includes(modelId)
    }

    isemergencySW(modelId){//是緊急按鈕就回傳true
        modelId = parseInt(modelId)
        let d = [41]
        return d.includes(modelId)
    }

    isFlood(modelId){//是淹水感測器就回傳true
        modelId = parseInt(modelId)
        let d = [42]
        return d.includes(modelId)
    }

    isshock(modelId){//是振動感測器(玻璃門窗感應器)就回傳true
        modelId = parseInt(modelId)
        let d = [43]
        return d.includes(modelId)
    }

    isUltronHub(modelId){//是奧創無限中樞就回傳true
        modelId = parseInt(modelId)
        let d = [44]
        return d.includes(modelId)
    }
//=================================設備類型的定義end===================================
    deviceKind(modelId){//判斷modelId是哪種設備類型
        // console.log(modelId)
        modelId = parseInt(modelId)

        if(this.isCamera(modelId)) return 'camera'

        if(this.isDoor(modelId)) return 'doorlock'

        if(this.isNvr(modelId)) return 'nvr'

        if(this.isPir(modelId)) return 'pir'

        if(this.isSmoke(modelId)) return 'smoke'

        if(this.isRhtemp(modelId)) return 'Rhtemp'

        if(this.isC1(modelId)) return 'C1'

        if(this.isD1(modelId)) return 'D1'

        if(this.isalarm(modelId)) return 'alarmOn'

        if(this.isemergencySW(modelId)) return 'click'

        if(this.isFlood(modelId)) return 'waterLeak'

        if(this.isshock(modelId)) return 'vibrated'

        if(this.isUltronHub(modelId) || this.isC1D1host(modelId) || this.isOtherhost(modelId)) return 'other'
    }

    nodeInfo(deviceType){//回傳api需要的點位名稱資訊
        console.log(deviceType)
        switch(deviceType){
            case '攝影機':
            return 'aiDetection'
            default:
            return deviceType
        }
    }

    getallcam(commulityId){//社區下所有攝影機
        return new Promise((resolve) => {
            serviceProxy.getApi(`WebAPI/api/Device/list?commulityId=${commulityId}`)
            .then((res)=>{
                let map = res.data.map(item=>{
                    if(this.isCamera(item.modelId)){
                        return{
                            ...item 
                         }
                    } 
                })
                resolve(map)
            })
            .catch((err)=>{console.log(err)})
        })
    }

    async deviceOption(communityId, filter){//建立設備類型下拉選單
        let devlist = await this.getdevice(communityId)  
        let uniqudev = new Set()
        let arr = []
        devlist.map((item) =>{
            if(filter === 'alarmOption'){
                if (!uniqudev.has(item.modelName) && !this.isNvr(item.modelId) && !this.isC1D1host(item.modelId)
                 && !this.isC1(item.modelId) && !this.isD1(item.modelId) && !this.isOtherhost(item.modelId)) 
                {
                    uniqudev.add(item.modelName)
                    arr.push({//設備類型下拉選單
                        name: item.modelName,
                        value: item.modelName
                    })
                }
            }else if(filter === 'manageOption'){
                if (!uniqudev.has(item.modelName) && !this.isC1D1host(item.modelId)) {
                    uniqudev.add(item.modelName)
                    arr.push({//設備類型下拉選單
                        name: item.modelName,
                        value: item.modelName
                    })
                }
            }else{
                if (!uniqudev.has(item.modelName)) {
                    uniqudev.add(item.modelName)
                    arr.push({//設備類型下拉選單
                        name: item.modelName,
                        value: item.modelName
                    })
                }
            }
            
        })
        return arr
    }

    async roleOption(groupId){//建立角色下拉選單
        let list = await this.allrole(groupId)
        let arr = []
        list.map(item=>{
            arr.push({
                label:item.name,
                value:item.groupId
            })
        })
        return arr
    }
    // sortBytime(list, order){//時間排序 ie無效
    //     list.sort((a, b)=>{
    //         const dateA = new Date(a.time).getTime()
    //         const dateB = new Date(b.time).getTime()
    //         console.log(new Date(a.time))
    //         console.log(new Date(b.time))
    //         if (order === 'ascending') {
    //             return dateA - dateB
    //         } else {
    //             return dateB - dateA
    //         }
    //     })
    // }
    // sortBystroke(list){
    //     return list.sort((a, b) => {
    //         return a.sublogtype.localeCompare(b.sublogtype, 'zh-Hant-TW', { usage: 'stroke' })
    //     })
    // }
    checkEngineer() {
        let groupId = localStorage.getItem('role')
        if ( groupId === '11011000-0000-0000-0000-000000000000' ) {
            return true
        } else {
            return false
        }
    }
    getUserInfo() {
        try {
        // 先取得登入者身分，後續比對用
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            return userInfo
        } catch (error) {
            console.log('JSON parse error', error)
            return ''
        }
    }
    getAcl(communityId){//取得社區下角色對頁面的權限
        return new Promise((resolve) => {
            let groupId = localStorage.getItem('role')
            if(!groupId){
                resolve(null)
                return
            }
            // 工務身分，開全部權限
            if (groupId == '11011000-0000-0000-0000-000000000000') {
                resolve({
                    '00000000-0000-0000-0000-000000000001': 0, // 社區服務
                    '00000000-0000-0000-0000-000000000002': 7, // 門禁管理
                    '00000000-0000-0000-0000-000000000003': 7, // 影像管理
                    '00000000-0000-0000-0000-000000000004': 7, // 事件告警
                    '00000000-0000-0000-0000-000000000005': 7, // 住戶管理
                    '00000000-0000-0000-0000-000000000006': 7, // 車牌辨識
                    '00000000-0000-0000-0000-000000000007': 7, // 設備應用
                    '00000000-0000-0000-0000-000000000008': 7  // 系統管理
                })
            }
            // 客服，業務身分，鎖全部權限
            else if (
                groupId == '11011100-0000-0000-0000-000000000000' ||
                groupId == '11011110-0000-0000-0000-000000000000'
            ) {
                resolve({
                    '00000000-0000-0000-0000-000000000001': 0,
                    '00000000-0000-0000-0000-000000000002': 0,
                    '00000000-0000-0000-0000-000000000003': 0,
                    '00000000-0000-0000-0000-000000000004': 0,
                    '00000000-0000-0000-0000-000000000005': 0,
                    '00000000-0000-0000-0000-000000000006': 0,
                    '00000000-0000-0000-0000-000000000007': 0,
                    '00000000-0000-0000-0000-000000000008': 0
                })
            }
            // TODO 之後可能有同帳號需要登不同平台的需求，不同平台會有不同權限身分，需要修改
            // let groupId = 'cdc9c039-e802-407e-9ab0-a0485b1c305a' // 測試用角色id
            else if ( groupId ) {
                serviceProxy.getApi(`AccountAPI/api/Acl/listPageAcl?commulityId=${communityId}&groupId=${groupId}`)
                .then(async(res)=>{
                    // let role = await this.allrole(communityId)
                    // let find = role.filter((el)=>el.groupId === groupId)
                    // 條件 find.length !== 0 此角色權限需存在角色列表內才能通過
                    let acl = ''
                    if(res.result === 'S0000' && groupId in res.data){
                        acl =  res.data[groupId]
                    }else{
                        acl = null
                    }
                    resolve(acl)
                }).catch((err)=>{console.log(err)})
            } 
        })
    }

    accessAll(num){//所有權限
        let disabled = num === 7
        return !disabled
    }

    readOnly(num){//檢視
        let disabled = num === 1
        return disabled
    }
    
    writeOnly(num){//數值修改
        let disabled = num === 2
        return disabled
    }

    Noaccess(num){//完全無權限
        let disabled = num === 0 || !num 
        return disabled
    }

    goRoute(router, pathname, _id){//前往路由
        if(_id){
            router.push({
                name: pathname,
                params: { id: _id }
            })
        }
        else{
            router.push({name: pathname})
        }
    }

    setSW(devid, sw){//設備開啟開關
        return new Promise((resolve) => {
            serviceProxy.postApi(`WebAPI/api/Device/sendCmd/setSw/${devid}`,
            {
             'sw':sw
            }
            )
            .then((res)=>{
                resolve(res)
            })
            .catch((err)=>{console.log(err)})
        })
    }
    transWeek(key){//轉換週期資料為中文
        switch(key){
            case 'mon':
            return '週一'
            case 'tue':
            return '週二'
            case 'wed':
            return '週三'
            case 'thu':
            return '週四'
            case 'fri':
            return '週五'
            case 'sat':
            return '週六'
            case 'sun':
            return '週日'
        }
    }
}

var shareds = new Shareds()

export default shareds